import styled from 'styled-components';

interface Props {
  children: React.ReactNode;
  width?: string;
}

export default function FormWrapper({ children, width }: Props): JSX.Element {
  return <StyledFromWrapper width={width}>{children}</StyledFromWrapper>;
}

const StyledFromWrapper = styled.div`
  padding: 75px 100px;
  background-color: #f4f4f4;
  border-radius: 10px;
  margin: 0 20px 40px 20px;
  display: flex;
  justify-content: center;
  form {
    width: ${(props) => (props.width ? props.width : '440px')};
  }
`;
